import React, { useEffect, useState } from 'react';
import { useConsultationContext } from '../../context/ConsultationContext';

import { HistoryTable } from '../UI/SelectedSalesOrder/HistoryTable';
import { VideoConsultingRoom } from '../../screens/screens';
import { useAppDispatch, useAppSelector } from '../../store/store';
import {
  resetUpdateStatus,
  selectConsultationStatusUpdateStatus,
} from '../../store/slices/workOrderServiceConsultation';
import { ConsultationTypes } from '../../enums/enums';
import { IDigitalHealthProfile } from '../UI/SelectedSalesOrder/DigitalHealthProfileTab';
import ConsultationsChat from '../../screens/Consultations/Tabs/ConsultationsChat';
import UserInfo from './UserInfo';
import VideoConsultationP2P from '../../screens/VideoConsultationP2P/VideoConsultationP2P';
import SignalingContextProvider from '../../context/P2PVideoConsultation/SignalingContext';
import MediaContextProvider from '../../context/P2PVideoConsultation/MediaContext';
import WithLoader from '../WithLoader/WithLoader';
import styles from './ConsultationParentComponent.module.scss';
import { useTranslation } from '../../hooks/useTranslations';

export default function LeftPanel() {
  const { translations } = useTranslation();
  const dispatch = useAppDispatch();
  const consultationStatusUpdateStatus: string = useAppSelector<string>(
    selectConsultationStatusUpdateStatus
  );
  const { selectedSalesOrder, workOrderStatusId, productOrder, isReports } =
    useConsultationContext();
  const [showVideoConsulting, setShowVideoCosulting] = useState<boolean>(false);
  const [productWithConversation, setProductWithConversation] = useState<IDigitalHealthProfile>();

  useEffect(() => {
    if (productOrder && productOrder?.conversation_id) {
      setProductWithConversation(productOrder);
    }
  }, [productOrder]);

  useEffect(() => {
    if (
      selectedSalesOrder.service_service_group.service_group_id ===
        ConsultationTypes.FACE_TO_FACE_CONSULTATION ||
      selectedSalesOrder.service_service_group.service_group_id ===
        ConsultationTypes.REVIEW_CONSULTATION
    ) {
      setShowVideoCosulting(false);
      return;
    }

    if (consultationStatusUpdateStatus === 'fulfilled') {
      dispatch(resetUpdateStatus());
    }

    if (workOrderStatusId === 6) {
      if (isReports) {
        setShowVideoCosulting(false);
      } else {
        setShowVideoCosulting(true);
      }
    }
    return () => {
      setShowVideoCosulting(false);
    };
  }, [consultationStatusUpdateStatus, workOrderStatusId]);

  return (
    <WithLoader isLoading={productOrder === undefined}>
      {showVideoConsulting ? (
        productOrder?.video_settings && productOrder?.video_settings[0] === 'P2P' ? (
          <MediaContextProvider>
            <SignalingContextProvider>
              <VideoConsultationP2P selectedSalesOrder={selectedSalesOrder} />
            </SignalingContextProvider>
          </MediaContextProvider>
        ) : (
          <VideoConsultingRoom selectedSalesOrder={selectedSalesOrder} />
        )
      ) : productWithConversation && workOrderStatusId === 2 ? (
        <ConsultationsChat product={productWithConversation} />
      ) : (
        <>
          <UserInfo selectedSalesOrder={selectedSalesOrder} />
          <div className={styles.devider} />
          <p className={`${styles.title} ${styles.mb2} ${styles.px1}`}>
            {translations('appointment.history')}
          </p>
          <HistoryTable
            customer_person_id={selectedSalesOrder?.customer_person.person_id}
            isInConsultation={true}
          />
        </>
      )}
    </WithLoader>
  );
}
